import { render, staticRenderFns } from "./SupplierAccountEditView.vue?vue&type=template&id=bebdfb64"
import script from "./SupplierAccountEditView.vue?vue&type=script&lang=js"
export * from "./SupplierAccountEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports